<template>
  <v-container fluid class="mx-0 px-0 my-0 py-0">
    <div
      class="mb-4 d-flex justify-space-between"
      v-if="searchBar || searchBar === undefined"
    >
      <v-text-field
        flat
        solo
        v-model="search"
        class="max-width-500"
        style="border: 1px solid #23919e; border-radius: 6px"
        append-icon="mdi-magnify"
        label="Найти"
        single-line
        hide-details
      ></v-text-field>
    </div>
    <div style="max-height: 200px; overflow-y: auto">
      <v-data-table
        class="table"
        :mobile-breakpoint="0"
        :items="value || []"
        :headers="headers"
        @input="itemSelected"
        @click:row="handleRowClick"
        dense
        multi-sort
        :show-select="selectable"
        :single-select="singleSelect"
        :search="search"
        hide-default-footer
        :items-per-page="-1"
        checkbox-color="primary"
      >
        <template #[`item.actions`]="{ item }">
          <div class="d-flex justify-start" @click.stop>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                  @click.stop="$emit('doRefundItem', item)"
                  color="success"
                  v-if="showActions?.refund && item.canRefund"
                >
                  <v-icon small>mdi-cash-refund</v-icon>
                </v-btn>
              </template>
              <span>Вернуть средства за сессию</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                  @click.stop="$emit('doEditItem', item)"
                  color="primary"
                  v-if="showActions?.edit"
                >
                  <v-icon small>
                    {{
                      content_type === "products"
                        ? "mdi-play"
                        : "mdi-playlist-edit"
                    }}
                  </v-icon>
                </v-btn>
              </template>
              <span>{{
                content_type === "products" ? "Открыть сессию" : "Редактировать"
              }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                  @click.stop="$emit('generateUrl', item)"
                  color="primary"
                  v-if="showActions?.url"
                >
                  <v-icon small>mdi-content-copy</v-icon>
                </v-btn>
              </template>
              <span>Скопировать ссылку на курс</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                  @click.stop="$emit('doResetWatchTime', item)"
                  color="primary"
                  v-if="showActions?.reset"
                >
                  <v-icon small>mdi-timer-refresh-outline</v-icon>
                </v-btn>
              </template>
              <span>Сбросить время просмотра</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                  @click.stop="$emit('doResetSessionTimer', item)"
                  color="primary"
                  v-if="showActions?.resetSessionTimer"
                >
                  <v-icon small>mdi-timer-off</v-icon>
                </v-btn>
              </template>
              <span>Сбросить таймаут сессии следующей сессии</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                  @click.stop="$emit('doResetViewProgress', item)"
                  color="primary"
                  v-if="showActions?.resetViewProgress"
                >
                  <v-icon small>mdi-play-circle-outline</v-icon>
                </v-btn>
              </template>
              <span>Сбросить прогресс просмотра текущей сессии</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                  @click.stop="$emit('doResetCourse', item)"
                  color="warning"
                  v-if="showActions?.resetCourse && user?.role === 'admin'"
                >
                  <v-icon small>mdi-restart</v-icon>
                </v-btn>
              </template>
              <span>Полностью сбросить курс в начальное состояние</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                  @click.stop="$emit('doDeleteItem', item)"
                  color="error"
                  v-if="showActions?.delete"
                >
                  <v-icon small>mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>Удалить</span>
            </v-tooltip>
          </div>
        </template>
      </v-data-table>
    </div>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "ObjectGrid",
  components: {},
  props: [
    "content_type",
    "title",
    "value",
    "field-defs",
    "hide-toolbar",
    "show-actions",
    "selectable",
    "single-select",
    "search-bar",
  ],
  emits: [
    "doEditItem",
    "generateUrl",
    "doDeleteItem",
    "doRefundItem",
    "doResetWatchTime",
    "doResetSessionTimer",
    "doResetViewProgress",
    "itemSelected",
    "row-click",
  ],
  data() {
    return {
      search: "",
      selected: undefined,
    };
  },
  computed: {
    ...mapGetters(["user"]),
    headers() {
      return this.fieldDefs;
    },
  },
  methods: {
    itemSelected(v) {
      this.selected = v;
      this.$emit("itemSelected", v);
    },
    handleRowClick(item) {
      if (this.showActions?.edit && !this.selectable) {
        this.$emit("row-click", item);
      }
    },
  },
};
</script>

<style scoped lang="scss">
table td {
  font-size: 12px;
}
</style>

<style lang="scss">
.table tbody tr:nth-child(even) {
  background-color: #f0f8f6;
}
table thead tr th {
  background-color: #23919e;
  color: white !important;
  font-size: 12px !important;
  font-weight: normal;
}
table tbody tr td {
  font-size: 12px !important;
}
table tbody tr {
  cursor: pointer;
}
</style>
